"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionPicker = void 0;
const FeatureStatus_1 = __importDefault(require("@opsbase/lib-system/FeatureStatus"));
const WorkflowActionType_1 = __importDefault(require("@opsbase/lib-workflow/WorkflowAction/WorkflowActionType"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const react_1 = __importDefault(require("react"));
const AssignIssueActionPicker_1 = __importDefault(require("./AssignIssueActionPicker"));
const AssignOpActionPicker_1 = __importDefault(require("./AssignOpActionPicker"));
const IQMActionPicker_1 = __importDefault(require("./IQMActionPicker"));
const NotifyAssetActionPicker_1 = __importDefault(require("./NotifyAssetActionPicker"));
const NotifyIssueActionPicker_1 = __importDefault(require("./NotifyIssueActionPicker"));
const NotifyOpActionPicker_1 = __importDefault(require("./NotifyOpActionPicker"));
const RaiseIssueActionPicker_1 = __importDefault(require("./RaiseIssueActionPicker"));
const SendMailActionPicker_1 = __importDefault(require("./SendMailActionPicker"));
const SendSmsActionPicker_1 = __importDefault(require("./SendSmsActionPicker"));
const SetDeadlineActionPicker_1 = __importDefault(require("./SetDeadlineActionPicker"));
function ActionPicker(props) {
    const { action, onChangeAction, event, disabled = false } = props;
    const self = (0, useSelf_1.default)();
    const iqmIntegrationSetting = self.features.find(f => f.name === 'INTEGRATIONS_IQM');
    const isIQMEnabled = iqmIntegrationSetting
        ? iqmIntegrationSetting.state === FeatureStatus_1.default.ENABLED
        : false;
    switch (action.workflowActionType) {
        case WorkflowActionType_1.default.NOTIFY_ASSET:
            return (react_1.default.createElement(NotifyAssetActionPicker_1.default, { disabled: disabled, event: event, action: action, onChangeAction: onChangeAction }));
        case WorkflowActionType_1.default.NOTIFY_ISSUE:
            return (react_1.default.createElement(NotifyIssueActionPicker_1.default, { disabled: disabled, event: event, action: action, onChangeAction: onChangeAction }));
        case WorkflowActionType_1.default.NOTIFY_OP:
            return (react_1.default.createElement(NotifyOpActionPicker_1.default, { disabled: disabled, event: event, action: action, onChangeAction: onChangeAction }));
        case WorkflowActionType_1.default.SEND_EMAIL:
            return (react_1.default.createElement(SendMailActionPicker_1.default, { disabled: disabled, event: event, action: action, onChangeAction: onChangeAction }));
        case WorkflowActionType_1.default.SET_ISSUE_DEADLINE:
            return (react_1.default.createElement(SetDeadlineActionPicker_1.default, { disabled: disabled, action: action, onChangeAction: onChangeAction }));
        case WorkflowActionType_1.default.ASSIGN_ISSUE:
            return (react_1.default.createElement(AssignIssueActionPicker_1.default, { disabled: disabled, action: action, onChangeAction: onChangeAction }));
        case WorkflowActionType_1.default.ASSIGN_OP:
            return (react_1.default.createElement(AssignOpActionPicker_1.default, { disabled: disabled, action: action, onChangeAction: onChangeAction }));
        case WorkflowActionType_1.default.ASSIGN_OP_ISSUE_CLOSED:
            return (react_1.default.createElement(AssignOpActionPicker_1.default, { disabled: disabled, type: 'issue', action: action, onChangeAction: onChangeAction }));
        case WorkflowActionType_1.default.RAISE_ISSUE:
            return (react_1.default.createElement(RaiseIssueActionPicker_1.default, { disabled: disabled, action: action, onChangeAction: onChangeAction }));
        case WorkflowActionType_1.default.SEND_SMS:
            return (react_1.default.createElement(SendSmsActionPicker_1.default, { disabled: disabled, action: action, event: event, onChangeAction: onChangeAction }));
        case WorkflowActionType_1.default.IQM_CREATE_WORKFLOW:
            return (react_1.default.createElement(IQMActionPicker_1.default, { isIQMEnabled: isIQMEnabled, settings: self.settings, disabled: disabled || !isIQMEnabled, action: action, event: event, onChangeAction: onChangeAction }));
        default:
            return react_1.default.createElement(react_1.default.Fragment, null);
    }
}
exports.ActionPicker = ActionPicker;
exports.default = ActionPicker;
